import { Button } from "@/components/ui/button"
import { Typography } from "@/components/ui/typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Minus, Plus } from "lucide-react"

export const ZOOM_MIN = 30
export const ZOOM_MAX = 150
export const ZOOM_STEP = 10

/** − 100% + — shared by the declaration block editor and the template
 *  editor. The caller applies `zoom` (CSS `zoom: <n>%`) to its document. */
export function ZoomControl({
  zoom,
  onZoom,
  className,
}: {
  zoom: number
  onZoom: (next: number) => void
  className?: string
}) {
  const { translate } = useTranslation()
  return (
    <span className={className}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label={translate("MC_CS_CONF_EDIT_ARIA_ZOOM_OUT")}
        disabled={zoom <= ZOOM_MIN}
        onClick={() => onZoom(Math.max(ZOOM_MIN, zoom - ZOOM_STEP))}
        className="h-7 w-7 text-grey5 hover:text-white"
      >
        <Minus size={14} />
      </Button>
      <Typography as="small" className="font-mono text-[11px] text-grey5">
        {zoom}%
      </Typography>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label={translate("MC_CS_CONF_EDIT_ARIA_ZOOM_IN")}
        disabled={zoom >= ZOOM_MAX}
        onClick={() => onZoom(Math.min(ZOOM_MAX, zoom + ZOOM_STEP))}
        className="h-7 w-7 text-grey5 hover:text-white"
      >
        <Plus size={14} />
      </Button>
    </span>
  )
}
